import { BidContractsTableV2 } from "src/components/bid-contracts/BidContractsTableV2";
import { PageHeader } from "src/routes/layout/PageHeader";

export function GlobalBidContractsPage() {
  return (
    <>
      <PageHeader title="Contracts" />
      <BidContractsTableV2 />
    </>
  );
}
